import { FormGroup } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Output, EventEmitter } from '@angular/core';
import { RegisterOfBenefactorsEventType } from '../register-of-benefactors.event.type';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { BenefactorDataModel } from '../../models/benefactorData';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-add-benefactors',
	templateUrl: './add-benefactors.component.html',
	styleUrls: ['./add-benefactors.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class AddBenefactorsComponent implements OnInit, OnDestroy {

	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="add-benefactors"]';
	private form: FormGroup;
	public active = false;
	public hasSubmited = false;
	public activeBackButton = false;
	public delete = false;
	public benefactorData = new BenefactorDataModel;
	public showStepButtons = true;

	constructor() {}

	ngOnInit() {
		AppEventDispatcher.listen(RegisterOfBenefactorsEventType.BUTTONS, () => {

			TweenMax.to('.buttons', .8, { bottom: '-100%', ease: Quint.easeOut });
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, { bottom: 0, ease: Quint.easeOut });
				});
			});

		});

		AppEventDispatcher.listen(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_ADD, data => {
			TweenMax.delayedCall(.1, () => {
				if (data.show) {
					this.showStepButtons = true;

					if (data.benefactor) {
						const benefactor = data.benefactor;
						this.benefactorData = {
							'id': benefactor.accounts[data.accountIndex].id,
							'name': benefactor.name,
							'cpfCnpj': benefactor.cpfCnpj,
							'bankCode': benefactor.accounts[data.accountIndex].bankCode,
							'bankDesc': benefactor.accounts[data.accountIndex].bankDesc,
							'modality': benefactor.accounts[data.accountIndex].modality,
							'agency': benefactor.accounts[data.accountIndex].agency,
							'accountNumber': benefactor.accounts[data.accountIndex].accountNumber,
							'ownership' : benefactor.ownership
						};
					} else {
						this.benefactorData  = {};
					}

					this.delete = data.delete ? data.delete : false;

					this.show();
				} else {
					this.hide();
				}
			});
		});
	}


	show() {
		this.active = true;
		TweenMax.delayedCall(.3, () => {
			TweenMax.to('.buttons', .8, { delay: .8, bottom: 0, ease: Quint.easeOut });
			if (this.delete) {
				AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_CONFIRMATION, {});
			} else {
				AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_DATA, {});
			}
		});
	}

	hide() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_LIST, { show: true, benefactorData: this.benefactorData });
			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}

	onSetForm(form: FormGroup) {
		this.form = form;
	}

	onSetTitle(data) {
		this.setTitle.emit({
			title: data.title,
		});
	}

	sendForm() {
		this.hasSubmited = true;

		if (this.form.valid) {
			this.hasSubmited = false;

			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { hide: true });

			if (!this.benefactorData.resumeList) {
				AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.BENEFACTOR.SEND_DATA, {});
			} else {
				AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.BENEFACTOR.CONFIRM_DATA, {});
			}
		}
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_ADD);
		AppEventDispatcher.removeListener(RegisterOfBenefactorsEventType.ERROR);
		AppEventDispatcher.removeListener(RegisterOfBenefactorsEventType.BUTTONS);
	}

	public onShowStepButtons(value: boolean) {
		this.showStepButtons = value;
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/register-of-benefactors/add-benefactors/add-benefactors.component.ts